const StartupPage = () => {
    return (
        <div>
            <video
            className="absolute inset-0 h-full w-full object-cover"
            src="https://thoughtfuloasis-public.s3.us-east-1.amazonaws.com/Startup-web.mp4"
            controls
            muted
            playsInline
            loop
            preload="metadata"
            title="Startup Page Video"
        >
            <source src="https://thoughtfuloasis-public.s3.us-east-1.amazonaws.com/Startup-web.mp4" type="video/mp4" />
            Your browser does not support the video tag.
        </video>
        </div>
    )
}

export default StartupPage;